import type { BlockCarousel, CarouselList } from 'types/block-carousel';
import React from 'react';
import Image from 'next/image';
import {
  Wrap,
  Paragraph,
  Heading,
  Carousel as CarouselComponent,
} from '@leafwell/components';
import TextHighlight from './text-highlight';
import Figure from './figure';
import HeadingBody from './heading-body';

const CarouselItem: React.FC<CarouselList> = ({
  title,
  description,
  videoUrl,
  thumbnail,
  signature,
}) => {
  const FigureWrap = videoUrl ? 'a' : 'div';

  return (
    <article className="w-full flex flex-col items-center sm:flex-row sm:items-start relative">
      <FigureWrap
        {...(videoUrl
          ? {
              href: videoUrl,
              rel: 'noopener noreferrer',
              target: '_blank',
              className: 'relative',
            }
          : {})}
      >
        {thumbnail && (
          <Figure
            {...thumbnail}
            className="aspect-w-4 aspect-h-6 w-60	rounded-2xl"
            objectFit="cover"
          />
        )}
        {videoUrl && (
          <Image
            src="/play-button.svg"
            className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 transition-opacity hover:opacity-70"
            width={106}
            height={86}
            alt="play button"
          />
        )}
      </FigureWrap>
      <div className="pt-4 md:pt-6 sm:pl-8 text-left">
        <HeadingBody level="5" title={title} />
        <Paragraph size="small" variant="medium" className="py-3">
          {description}
        </Paragraph>
        {signature ? <Figure {...signature} className="w-40" /> : null}
      </div>
    </article>
  );
};

const Carousel: React.FC<BlockCarousel> = ({ title, list }) => {
  return list?.length > 0 ? (
    <div className="w-screen overflow-hidden">
      <Wrap size="large">
        <HeadingBody level="3" title={title} className="font-semibold" />
        <CarouselComponent
          slideClassName="max-w-full md:max-w-2xl mr-8"
          autoPlay={true}
        >
          {list.map((item, index) => (
            <CarouselItem key={`carousel-item-${index}`} {...item} />
          ))}
        </CarouselComponent>
      </Wrap>
    </div>
  ) : null;
};

export default Carousel;
